import { Flex } from '@fabric-app/ui/components/Flex';
import { styled, css } from 'styled-components';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { cssHover } from '../sharedCss.js';
import { containerPreviewCompact } from '../cssPreviewContainer.js';
import { DESKTOP_CARD_WIDTH, DESKTOP_CARD_HEIGHT } from '@fabric-app/ui/theme/resourcePreviewConstants';
import { useResourceListPreferencesContextUnsafe } from '../../../ResourceList/contexts/resourceListContextPreferences.js';
import { renderCssBasedOnColorScheme } from '@fabric-app/ui/theme/renderCssBasedOnColorScheme';

const PreviewGridContainer = styled.div.withConfig({
  displayName: "PreviewContainer__PreviewGridContainer",
  componentId: "sc-b7c3f31d-0"
})([
  `container-type:inline-size;container-name:previewContainer;display:flex;flex-direction:column;position:relative;`
]);
const PreviewGridSizingContainer = styled(Flex).attrs((props) => {
  const pref = useResourceListPreferencesContextUnsafe();
  const viewMode = pref?.viewMode;
  return {
    direction: "column",
    gap: 12,
    viewMode,
    ...props
  };
}).withConfig({
  displayName: "PreviewContainer__PreviewGridSizingContainer",
  componentId: "sc-b7c3f31d-1"
})([
  `position:relative;flex-grow:1;width:`,
  `px;`,
  ` --preview-border-color:rgba(`,
  `,0.05);--preview-compact-border-color:rgba(`,
  `,0.04);`,
  ` `,
  ` `,
  `{height:auto;width:auto;aspect-ratio:`,
  `;background:`,
  `;border-radius:1.125rem;overflow:hidden;border:2px solid var(--preview-compact-border-color);background:var(--preview-background-color,`,
  `);`,
  ` `,
  `}`
], DESKTOP_CARD_WIDTH, ({ viewMode, minusBaseHeight }) => {
  if (viewMode === "Masonry") {
    return css([
      `height:auto;`
    ]);
  }
  return css([
    `height:calc(`,
    `px - `,
    `px);`
  ], DESKTOP_CARD_HEIGHT, minusBaseHeight || 0);
}, cssVar["color-bg-primary-reverse-rgb"], cssVar["color-bg-primary-reverse-rgb"], renderCssBasedOnColorScheme({
  light: css([
    `--preview-compact-border-color:rgba(`,
    `,0.04);`
  ], cssVar["color-bg-primary-reverse-rgb"]),
  dark: css([
    `--preview-compact-border-color:rgba(`,
    `,0.06);`
  ], cssVar["color-bg-primary-reverse-rgb"])
}), (p) => {
  switch (p.variant) {
    case "spotify":
      return css([
        `--preview-background-color:#f5fff7;`,
        ``
      ], renderCssBasedOnColorScheme({
        light: css([
          `--preview-compact-border-color:rgba(`,
          `,0.03);`
        ], cssVar["color-bg-primary-reverse-rgb"]),
        dark: css([
          ``
        ])
      }));
    case "notepad":
      return css([
        `--preview-background-color:`,
        `;`,
        ``
      ], cssVar["color-bg-note-primary"], renderCssBasedOnColorScheme({
        light: css([
          `--preview-compact-border-color:rgba(`,
          `,0.03);`
        ], cssVar["color-bg-primary-reverse-rgb"]),
        dark: css([
          `--preview-compact-border-color:rgba(`,
          `,0.02);`
        ], cssVar["color-bg-primary-reverse-rgb"])
      }));
  }
}, containerPreviewCompact, cssVar["preview-compact-card-aspect-ratio"], cssVar["color-bg-primary"], cssVar["color-bg-primary"], cssHover, (p) => p.isSelected && css([
  `border-color:rgba(42,55,238,0.4);`
]));
const PreviewGridInnerLayout = styled(Flex).attrs((props) => {
  return {
    direction: "column",
    gap: 12,
    ...props
  };
}).withConfig({
  displayName: "PreviewContainer__PreviewGridInnerLayout",
  componentId: "sc-b7c3f31d-2"
})([
  `position:relative;cursor:pointer;`,
  ` `,
  `{overflow:hidden;flex-grow:1;gap:0;&:before{display:none;}}`
], (p) => p.isSelected ? (
  /** Selected */
  css([
    `position:relative;&::after{content:' ';position:absolute;inset:-10px;background:rgba(42,55,238,0.2);border-radius:1.625rem;z-index:2;border:2px solid rgba(42,55,238,0.4);pointer-events:none;}`
  ])
) : css([
  `@media (hover:hover){&:before{display:block;content:'';inset:-10px;background:rgba(`,
  `,0.03);position:absolute;border-radius:1.625rem;opacity:0;transition:0.1s opacity;pointer-events:none;}&:hover:before{opacity:1;}}`
], cssVar["color-bg-primary-reverse-rgb"]), containerPreviewCompact);
const ResourcePreviewGridItemMetaContent = styled(Flex).attrs((props) => {
  return {
    direction: "column",
    alignItems: "center",
    ...props
  };
}).withConfig({
  displayName: "PreviewContainer__ResourcePreviewGridItemMetaContent",
  componentId: "sc-b7c3f31d-3"
})([
  `gap:0.625rem;position:relative;`,
  `{align-items:flex-start;gap:0;}`
], containerPreviewCompact);

export { PreviewGridContainer, PreviewGridInnerLayout, PreviewGridSizingContainer, ResourcePreviewGridItemMetaContent };
//# sourceMappingURL=PreviewContainer.js.map
